import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export interface DialogData {
  title: string;
  alertDescription?: string;
  showActionBtn: boolean;
  icon?: string;
  alertType: 'success' | 'error' | 'warning' | 'info';
  closeText?: string;
  actionText?: string;
  timed?: boolean;
  time?: number;
  disableClose?: boolean;
  onAction?: () => void;
}

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: false,
})
export class AlertModalComponent {
  @ViewChild('positionModal', { static: false }) positionModal!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<AlertModalComponent>,
    @Inject(MAT_DIALOG_DATA) public alertData: DialogData,
  ) {}

  closeAlert(): void {
    if (!this.alertData.showActionBtn) this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Function to be called when the action button is clicked
   */
  onActionClick(): void {
    if (this.alertData.onAction) {
      this.alertData.onAction();
    }
    this.dialogRef.close();
  }
}
